const App = () => {
  return (
    <div>
      <p className="text-red-700">development and types</p>
    </div>
  );
};

export default App;
